module.exports = __webpack_public_path__ + "static/media/WhatsAnInitiativesBanner.bc17b85d.svg";